(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.messages');
    module.factory('MessageService', ['$http', 'HelperService', 'SharedAgendaService', MessageServiceFn]);

    /* main service for message APIs  */
    function MessageServiceFn($http, HelperService, SharedAgendaService) {

        var baseUrl = '/api/messages/';
        var service = {
            query: query,
            //get: get,
            update: update,
            deleteMessage: deleteMessage,
            search: search,
            play: play,
            list: list
        };

        return service;

        // play record
        function play(id) {
            return $http.get(baseUrl + 'play/' + id).then(function (result) {
                return result.data;
            });
        }
        
        function list(userId, pageSize, pageNumber, includeCount, all) {
            return $http({
                    url: '/api/messages',
                    method: "GET",
                    params: {
                        userId: userId,
                        pageSize: pageSize,
                        pageNumber: pageNumber,
                        includeCount: includeCount,
                        all: all
                    },
                }).then(result =>
            {
                return result.data;
            });
        }

        /* get all items */
        function query(userId, messageTypes, date) {
            return $http({
                url: baseUrl + 'users/' + userId + '/false',
                method: 'GET',
                params: {
                    types: messageTypes ? messageTypes : [],
                    date: date ? HelperService.backendDate(date) : null
                }
            }).then(function(response) {
                if (response.data) {
                    const messages = [];
                    const transcriptions = [];
                    
                    response.data.forEach(item => {
                        if (item.message) {
                            messages.push(item.message);  
                        }
                        if (item.transcription) {
                            transcriptions.push(item.transcription);  
                        }
                    });
                    return { messages, transcriptions };
                }
            });
        }

        ///* get one item */
        //function get(messageId) {
        //    return $http.get(baseUrl + messageId);
        //}

        /* update item */
        function update(messageId, item) {
            return $http.put(baseUrl + messageId + '/users/' + SharedAgendaService.currentUser().id, item);
        }

        /* delete item */
        function deleteMessage(messageId) {
            return $http.delete(baseUrl + messageId + '/users/' + SharedAgendaService.currentUser().id);
        }

        /* execute fulltext search */
        function search(userId, searchValue) {
            return $http.get(baseUrl + 'search/' + userId + '/' + searchValue).then(function (response) {
                return response.data;
            });
        }
    }
})();